import React from 'react'

// Module Steps

import ProductCurrencies from './Steps/1.ProductCurrencies';
import ClientConstancyFiles from './Steps/2.ClientConstancyFiles';
import TermsAndConditions from './Steps/3.TermsAndConditions';
import FormConfirmation from './Steps/4.FormConfirmation';

export default function ProductInfo({formik, formStep, setFormStep, goToPreviousModule, isSubmitting}) {
  return (
    <>
        {/* STEP 1: Product Currencies */}

        {formStep === 0 &&
        <ProductCurrencies
          formik={formik}
          goToPreviousModule={goToPreviousModule}
        />}

        {/* STEP 2: Client Constancy Files */}

        {formStep === 1 &&
        <ClientConstancyFiles
          formik={formik}
          formStep={formStep}
          setFormStep={setFormStep}
        />}

        {/* STEP 3: Terms and Conditions */}

        {formStep === 2 &&
        <TermsAndConditions
          formik={formik}
          formStep={formStep}
          setFormStep={setFormStep}
        />}

        {/* STEP 4: Form Confirmation */}

        {formStep === 3 &&
        <FormConfirmation
          formik={formik}
          formStep={formStep}
          setFormStep={setFormStep}
        />}

    </>
  )
}
